import { alpha, SxProps, Theme } from '@mui/material/styles';

export const deviceNameCellStyles = (
  theme: Theme,
  isIncident: boolean,
): SxProps<Theme> => ({
  fontWeight: isIncident ? 'bold' : 'normal',
  color: theme.palette.text.primary,
});

export const temperatureCellContainerStyles = (
  color: string,
): SxProps<Theme> => ({
  backgroundColor: alpha(color, 0.1),
  borderRadius: 0,
  padding: '4px 8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '70%',
  margin: 'auto',
  border: `1px solid ${alpha(color, 0.5)}`,
});

export const temperatureCellTextStyles = (
  color: string,
  isIncident: boolean,
): SxProps<Theme> => ({
  color,
  fontWeight: isIncident ? 'bold' : 'normal',
  textShadow: '0 1px 3px rgba(0,0,0,0.3)',
});

export const noDataTextStyles: SxProps<Theme> = {
  fontStyle: 'italic',
};

export const centerContainerStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
};

export const timestampCellContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  height: '100%',
};

export const historicalChartButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  minWidth: 'auto',
  padding: theme.spacing(0.5, 1),
  fontSize: '0.75rem',
  fontWeight: 500,
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  transition: 0,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.main,
    transition: 0,
  },
  '&:active': {
    transform: 'translateY(0)',
    boxShadow: theme.shadows[1],
    transition: 0,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
    transition: 0,
  },
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(0.5),
    marginLeft: 0,
    transition: 0,
  },
});
